const $ = window.$;

import Model from '../model/top';


export default class Top {
  constructor() {
    this.model = new Model;

    this.setHieght();
    this.renderStream(0, 10);
    this.bindEvents();
  }


// -----------------------------------------------------------------
//
// @method bindEvents
// -----------------------------------------------------------------
  bindEvents() {
    $(window).on('scroll', () => {
      this.model.setState('scroll');
    });

    $('#js-top-heroArrow').on('click', () => {
      this.scrollBottom();
    });

    $('#js-top-streamTab').find('li').on('click', (e) => {
      this.model.setState('stream', $(e.currentTarget).data('type'));
    });

    $('#js-top-streamMore').on('click', () => {
      this.onClickMoreStream();
    });


    $('#js-top-streamList').on('touchend', 'li', (e) => {
      this.onTapStream(e.currentTarget);
    });


    //
    // Modelからのイベント待ち受け
    //
    $('#js-topPage').on('toggleHeader', () => {
      this.toggleHeader(this.model.state.isHeaderFixed);
    });

    $('#js-topPage').on('stream', () => {
      this.onClickStream();
    });
  }




// -----------------------------------------------------------------
//
// @method setHieght
// -----------------------------------------------------------------
  setHieght() {
    const heroHeight = $(window).height();
    // $('#js-header').height()
    var setHeight = heroHeight * 0.70;
    console.log(setHeight);
    $('#js-top-hero').height(setHeight);
  }




// -----------------------------------------------------------------
//
// @method toggleHeader
// -----------------------------------------------------------------
  toggleHeader(isFixed) {
    // ヘッダーの位置をスクロール値が超えた時
    if(isFixed && $('#js-header').hasClass('is-top')) {
      $('#js-header').removeClass('is-top');

    } else if(!isFixed && !$('#js-header').hasClass('is-top')) {
      $('#js-header').addClass('is-top');
    }
  }




// -----------------------------------------------------------------
//
// @method scrollBottom
// -----------------------------------------------------------------
  scrollBottom() {
    $('html, body').animate({
      scrollTop: this.model.state.headerPos
    })
  }












// -----------------------------------------------------------------
//
// @method renderStream
// -----------------------------------------------------------------
  renderStream(min, max) {
    const delay = 100;
    let count = 0;

    const _initTemp = (el) => {
      count++;
      let temp = `
        <li class="fadeIn">
          <img src="/co/assets/img/sp/top/${el.img}" alt="" class="u-pc-hidden">
          <img src="/co/assets/img/pc/top/${el.img}" alt="" class="u-sp-hidden">
          <div class="p-top-stream__caption">
            <div class="p-top-stream__caption__inner">
              <img src="/co/assets/img/pc/top/${el.icon}" alt="" class="">
              <p class="p-top-stream__caption__txt">${el.txt}</p>
            </div>
          </div>
        </li>
      `;

      this.model.setState('streamTimer', setTimeout(() => {
        $('#js-top-streamList').append(temp)
      }, delay * count))
    }


    if(this.model.state.streamType === 'all') {
      for(let i = min; i < max; i++) {
        _initTemp(this.model.state.shuffleStreamArray[i]);
      }
    } else {
      for(let i = min; i < max; i++) {
        if(this.model.state.streamType === this.model.state.shuffleStreamArray[i].type) {
          _initTemp(this.model.state.shuffleStreamArray[i])
        }
      }
    }

  }




// -----------------------------------------------------------------
//
// @method onClickStream
// -----------------------------------------------------------------
  onClickStream() {
    if(this.model.state.streamTimer.length) {
      this.model.state.streamTimer.forEach((el, i) =>{
        clearTimeout(el)
      });
    }
    $('#js-top-streamList').empty();
    $('#js-top-streamTab').attr('data-streamtype', '').attr('data-streamtype', this.model.state.streamType);

    if(this.model.state.streamType === 'all') {
      this.model.state.isStreamMore ? this.renderStream(0, this.model.state.streamData.length) : this.renderStream(0, 10)
    } else {
      this.renderStream(0, this.model.state.streamData.length)
    }

  }






// -----------------------------------------------------------------
//
// @method onClickMoreStream
// -----------------------------------------------------------------
  onClickMoreStream() {
    if(!this.model.state.isStreamMore) {
      this.model.setState('streamMore');
      $('#js-top-streamMore').remove();
      this.renderStream(10, this.model.state.streamData.length)
    }
  }









// -----------------------------------------------------------------
//
// @method onTapStream
// -----------------------------------------------------------------
  onTapStream(tar) {
    const $tar = $(tar);

    $('#js-top-streamList').find('li').removeClass('is-tap');
    $tar.addClass('is-tap');
  }

}

$('.js-all').on({
  'click':function(){
    $('#js-top-streamMore').show();
  }
});

$('.js-person').on({
  'click':function(){
    $('#js-top-streamMore').hide();
  }
});

$('.js-climate').on({
  'click':function(){
    $('#js-top-streamMore').hide();
  }
});
$('.js-food').on({
  'click':function(){
    $('#js-top-streamMore').hide();
  }
});


/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/view/top.js
 **/